import React from "react";
import * as d3 from "d3";
import { sunColourMap, gradients } from "../../modules/colors-and-stuff";
import { betweenTimes, getSunPhase } from "../../modules/time-stuff";
import {
    getSunPosition,
    getMoonPosition,
} from "../../modules/getCelestialBodyPosition";

import Phone from "./app.png";
import Mockup from "./promo.jpg";
import AppStoreButton from '../../static/app_store_button.svg';

class Hero extends React.Component {

    renderBackground(gradient, sunColor, sunX, sunY, moonX, moonY) {
        return (
            <svg className="hero-background">
                <defs>
                    <linearGradient id={"hero-gradient"} x1="0" x2="0" y1="0" y2="1">
                        <stop style={{stopColor: gradient[0]}} offset="0%"/>
                        <stop style={{stopColor: gradient[1]}} offset="100%"/>
                    </linearGradient>
                </defs>
                <rect x={0} y={0} width="100%" height="100%" style={{ fill: "url(#hero-gradient)" }}/>
                <circle cx={sunX} cy={sunY} r={32} className="hero-sun" style={{ fill: sunColor }}/>
                <circle cx={moonX} cy={moonY} r={16} className="hero-moon"/>
            </svg>
        )
    }

    render() {
        const { date, coords } = this.props;
        const sunPos = getSunPosition(date.toDate(), coords.lat, coords.lng);
        const sunPhase = getSunPhase(date, sunPos);
        const moonPos = getMoonPosition(date.toDate(), coords.lat, coords.lng);
        const phaseGradient = gradients[sunPhase];
        const sunColor = sunColourMap[sunPhase];

        const sunMaxDistancePx = window.innerHeight;

        const sunDistanceScale = d3
        .scaleLinear()
        .domain([-Math.PI / 2, Math.PI / 2])
        .range([0, sunMaxDistancePx]);

        const sunDistance = sunDistanceScale(sunPos.altitude);
        const moonDistance = sunDistanceScale(moonPos.altitude);

        const originX = window.innerWidth / 2;
        const originY = window.innerHeight;
        const angleOffset = -(Math.PI / 2);

        const sunX = originX + Math.cos(angleOffset + sunPos.azimuth) * sunDistance;
        const sunY = originY + Math.sin(angleOffset + sunPos.azimuth) * sunDistance;

        const moonX = originX + Math.cos(angleOffset + moonPos.azimuth) * moonDistance;
        const moonY = originY + Math.sin(angleOffset + moonPos.azimuth) * moonDistance;

        const phoneX = originX;
        const phoneY = window.innerHeight / 2;

        const shadowSizeScale = d3
        .scaleLinear()
        .domain([0, Math.PI / 2])
        .range([20 * 1.414, 0]);

        const shadowOpacityScale = d3
        .scaleLinear()
        .domain([0, Math.PI / 2])
        .range([0, 0.2]);

        const shadowOpacity = shadowOpacityScale(sunPos.altitude);
        const phoneShadowLength = shadowSizeScale(sunPos.altitude);

        const phoneShadowAngle = Math.atan2(sunY - phoneY, sunX - phoneX) + (Math.PI);
        const phoneShadowX = `${Math.cos(phoneShadowAngle) * phoneShadowLength}px ${Math.sin(phoneShadowAngle) * phoneShadowLength}px rgba(0,0,0,${shadowOpacity})`

        return (
            <div className="hero">
                {this.renderBackground(phaseGradient, sunColor, sunX, sunY, moonX, moonY)}
                <div className="hero-layout">
                <div className="text-frame-uno">
                </div>
                <div className="hero-phone-container">
                    <div className="hero-phone" style={{ boxShadow: phoneShadowX }}>
                        <img className="hero-phone-frame" src={Phone} />
                    </div>
                </div>
                <div className="text-frame-due">
                    <h1>Hello, Sun.</h1>
                    <p>Visualise the sun's position through the seasons and see its effect on your surroundings in augmented reality. Use the app for gardening, interior design, and photography, optimise your life in the sun now!</p>
                    <a className="app-store-button" href="https://itunes.apple.com/app/hello-sun/id1332568975?mt=8">
                        <img src={AppStoreButton} alt=""/>
                    </a>
                </div>

                </div>
            </div>
        );
    }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/hero.js